<template>
    <div>
        <div class="columns">
            <div class="column is-3">
                <!-- Folders -->
                <FolderMenu v-model="selectedFolderId" :list="$store.state.folders" />
            </div>
            <div class="column">
                <FileListing :folderId="selectedFolderId" :type="type" :picker="picker" @select="(file) => $emit('select', file)" />
            </div>
        </div>
        <b-loading :active.sync="isLoading" :is-full-page="false"></b-loading>
    </div>
</template>

<script>
import FolderMenu from "./FolderMenu.vue";
import FileListing from "./FileListing.vue";
export default {
    name: "Gallery",
    components: {
        FolderMenu,
        FileListing,
    },
    props: {
        type: {
            type: String,
            defualt: "*",
        },
        picker: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // isViewImage: null,
            selectedFolderId: null,
            isLoading: false,
            files: [],
        };
    },
    watch: {
        // // New Folder is selected, get files from that folder
        // selectedFolderId(val) {
        //     if (val) {
        //         this.$http.get(`/folders/${val.id}/files`);
        //     }
        // },
    },
};
</script>

<style>
</style>